<script setup lang="ts">
import type { CmsBlockGalleryBuybox } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockGalleryBuybox;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const rightContent = getSlotContent("right");
const leftContent = getSlotContent("left");
</script>

<template>
  <div class="container max-w-[90rem] max-w-screen-2xl !mx-auto">
    <div class="lg:flex flex-wrap -mx-3 gap-y-10">
      <div class="overflow-hidden lg:w-1/2 px-3 mb-10 lg:mb-0">
        <CmsGenericElement :content="leftContent" />
      </div>
      <div
        class="lg:w-1/2 laptop:w-2/5 px-3 prose-p:text-sm prose-ul:text-sm text-skin-secondary prose-ul:mb-5"
      >
        <CmsGenericElement :content="rightContent" />
      </div>
    </div>
  </div>
</template>
